export const API_BONDS = '/bonds';

export const API_BOND_INFO = `${API_BONDS}/info`;
export const API_BOND_SIGN_REDEEM = `${API_BONDS}/sign-redeem`;
export const API_BOND_TOTAL_REWARDS_DISTRIBUTED = `${API_BONDS}/total-rewards-distributed`;
export const API_BOND_ACTION_HISTORY = `${API_BONDS}/action-history`;
export const API_BOND_PERFORMANCE_METRICS = `${API_BONDS}/performance-metrics`;
export const API_BOND_SIGN_MINT_AND_APPLY = `${API_BONDS}/sign-mint-and-apply`;
export const API_BOND_STATS_SNAPSHOTS = `${API_BONDS}/stats-snapshots`;
export const API_BOND_DISCLAIMER_ACCEPT = `${API_BONDS}/disclaimer/accept`;
export const API_BOND_DISCLAIMER_ACCEPTED = `${API_BONDS}/disclaimer/accepted`;

export const API_BOND_REFERRAL_ME = `${API_BONDS}/referral/me`;

export const API_COMMON_PERSONAL_KPI = '/common/personal-kpi';
